import script from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewsSection.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewsSection.vue?vue&type=style&index=0&id=a2fb2e6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2fb2e6a"]])

export default __exports__